import { render } from "./ReservationConfirmation.vue?vue&type=template&id=6054e1f0&scoped=true"
import script from "./ReservationConfirmation.vue?vue&type=script&lang=js"
export * from "./ReservationConfirmation.vue?vue&type=script&lang=js"

import "./ReservationConfirmation.vue?vue&type=style&index=0&id=6054e1f0&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6054e1f0"]])

export default __exports__